import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Link } from "@tanstack/react-router";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Skeleton } from "../ui/skeleton";
import { Button, buttonVariants } from "../ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/providers/auth.provider";
import { AuthState } from "@/types/auth.types";

const Profile = () => {
  const { user: data, authState, logout } = useAuth();

  const initials = `${data?.user?.firstName?.[0] ?? ""}${
    data?.user?.lastName?.[0] ?? ""
  }`;

  return (
    <button type="button" className="ml-auto">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Avatar className="size-10">
            {authState === AuthState.AUTHENTICATING ? (
              <Skeleton className="w-full h-full rounded-full" />
            ) : (
              <div className="bg-muted rounded-full w-full h-full flex items-center justify-center">
                <Avatar className="size-10 cursor-pointer">
                  <AvatarImage src={data?.user?.image ?? ""} />
                  <AvatarFallback className="bg-primary/10 text-primary">
                    {initials || "U"}
                  </AvatarFallback>
                </Avatar>
              </div>
            )}
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="space-y-1.5">
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="p-0">
            <Link
              to={"/profile"}
              className={cn(
                buttonVariants({
                  className: "w-full justify-start",
                  variant: "ghost",
                })
              )}
            >
              Settings
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="p-0">
            <Button
              type="button"
              variant={"outline"}
              className="w-full justify-start"
              onClick={logout}
            >
              Logout
            </Button>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </button>
  );
};

export default Profile;
